

// import { KTCard } from '../../../../_metronic/helpers'
// import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
// import { useAuth } from '../../auth'

import { KTCard } from '../../../../../_metronic/helpers'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import { useAuth } from '../../../auth'


// const features = (isPartner = false, isSupplyChainManager = false, currentUser: any = {}) => [

//     { name: 'Impact Partner', icon: 'sponsor', to: 'credit-buyer' },
//     { name: 'Commitment', icon: 'commitment', to: 'commitment' },
//     { name: 'Fulfillment', icon: 'fulfiment icon', to: 'fullfilment' },
//     { name: 'Engagement', icon: 'engagment', to: 'engagement' },
//     { name: 'Coupons', icon: 'engagment', to: 'coupons' },
//     { name: 'Membership Tires', icon: 'engagment', to: 'membership-tires' },

// ]




// const features = (isPartner = false, isSupplyChainManager = false, currentUser: any = {}) => {
//     const allFeatures = [
//         { name: 'Impact Partner', icon: 'sponsor', to: 'credit-buyer' },
//         { name: 'Commitment', icon: 'commitment', to: 'commitment' },
//         { name: 'Fulfillment', icon: 'fulfiment icon', to: 'fullfilment' },
//         { name: 'Engagement', icon: 'engagment', to: 'engagement' },
//         { name: 'Coupons', icon: 'engagment', to: 'coupons' },
//         { name: 'Membership Tires', icon: 'engagment', to: 'membership-tires' },
//     ]

//     if ((currentUser as any)?.userType === 'CLIENT') {
//         return allFeatures.filter(feature => feature.to !== 'membership-tires')
//     }

//     return allFeatures
// }




const features = (isPartner = false, isSupplyChainManager = false, currentUser: any = {}) => {
    const allFeatures = [
        { name: 'Impact Partner', icon: 'IMpact Partner', to: 'impact-partner' },
        { name: 'Commitment', icon: 'FTS Commitment icon', to: 'commitment' },
        { name: 'Fulfillment', icon: 'FTS', to: 'fullfilment' },
        { name: 'Engagement', icon: 'FTS Fulfillment icon', to: 'engagement' },
        { name: 'Coupons', icon: 'FTS Coupon', to: 'coupons' },
        { name: 'IP Tier', icon: 'FTS IP Tier', to: 'membership-tiers' },
    ]

    if ((currentUser as any)?.userType === 'CLIENT_USER' || (currentUser as any)?.userType === 'MARKETING') {
        return allFeatures.filter(feature =>
            feature.to === 'engagement' || feature.to === 'coupons'
        )
    }

    // if ((currentUser as any)?.userType === 'CLIENT') {
    //     return allFeatures.filter(feature => feature.to !== 'membership-tires')
    // }

    return allFeatures
}

const Menu = () => {
    const { isPartner, isSupplyChainManager, currentUser } = useAuth()
    console.log({ isPartner })
    return (
        <KTCard addCard={false}>
            <div className='row g-xl-4'>
                {features(isPartner, isSupplyChainManager, currentUser).map((eachFeatures, eachIndex) => (
                    <div key={eachIndex + 1 + ''} className='col col-lg-2'>
                        <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
                            <Card4
                                // icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                title={eachFeatures.name}
                                description=''
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </KTCard>
    )
}

const MaketingMenu = () => <Menu />
export { MaketingMenu }
